import React from 'react'
import styled from 'styled-components'
import AmenityCheckBox from './AmenityCheckBox'

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  grid-gap: 6px;
  box-sizing: border-box;
`

const AmenitySelect = ({amenities, selectedItems, onSelect}) => {
  const onCheckSelect = ({value, checked}) => {
    let newSelectedItems = []

    if (checked) {
      if (!selectedItems.some(e => e.value === value.value)) {
        newSelectedItems = selectedItems.slice(0)
        newSelectedItems.push(value)
      }
    } else {
      if (selectedItems.some(e => e.value === value.value)) {
        newSelectedItems = selectedItems.filter(
          item => item.value !== value.value
        )
      }
    }

    onSelect(newSelectedItems)
  }

  return (
    <Container>
      {amenities.map((item, idx) => {
        return (
          <AmenityCheckBox
            key={idx}
            label={item.title}
            index={idx}
            checked={selectedItems.some(e => e.value === item.value)}
            value={item}
            onSelect={onCheckSelect}
          />
        )
      })}
    </Container>
  )
}

AmenitySelect.defaultProps = {
  onSelect: () => {},
  selectedItems: [],
  amenities: []
}

export default AmenitySelect
